// @flow

import React, { PureComponent } from "react";
import type { RaceTypeCodeEnum } from "@tvg/types/Race";
import RunnerNumber from "../../_atom/RunnerNumber";
import { RunnerContainer, RunnerNumberContainer } from "./styled-components";

type ArrowDirectionEnum = "none" | "up" | "down";

type Props = {
  runnerId: string,
  raceTypeCode: RaceTypeCodeEnum,
  isFavorite: boolean,
  arrowDirection: ArrowDirectionEnum,
  runnerName: string
};

export default class RunnerNumberWithName extends PureComponent<Props> {
  static defaultProps = {
    runnerId: "",
    raceTypeCode: "T",
    isFavorite: false,
    arrowDirection: "none",
    runnerName: ""
  };

  render() {
    return (
      <RunnerContainer>
        {this.props.runnerId && (
          <RunnerNumberContainer>
            <RunnerNumber {...this.props} />
          </RunnerNumberContainer>
        )}
        {this.props.runnerName}
      </RunnerContainer>
    );
  }
}
